import { Popover as MantinePopover } from '@mantine/core';

import styled, { css } from 'styled-components';
import { smBold } from '../theme/typography';
import { themeColor } from '../theme/colors';
import { clickableMixin, ellipsisMixin } from '../theme/utils';

const Title = styled.div`
  ${smBold}
  background: ${themeColor('backgroundLight')};
  color: ${themeColor('textTertiary')};
  padding: 13px 16px;
`;

const Body = styled.div`
  ${smBold}

  padding: 16px;

  max-height: 200px;
  overflow: auto;

  & > * {
    ${ellipsisMixin}
  }
`;

const Popover = styled(MantinePopover).attrs({ unstyled: true })``;

const Target = styled(MantinePopover.Target)``;

const Dropdown = styled(MantinePopover.Dropdown)`
  position: absolute;
  ${smBold};
  border-radius: 6px;
  color: ${themeColor('textPrimary')};
  background: ${themeColor('buttonBackground')};
  overflow: hidden;
  z-index: 100;
`;

const TargetContainer = styled.div<{
  $clickable?: boolean;
}>`
  ${(props) =>
    props.$clickable &&
    css`
      ${clickableMixin}
    `}
`;

export default {
  Title,
  Body,
  Popover,
  Dropdown,
  Target,
  TargetContainer,
};
